/**
 * Refreshes the em-cart-totals sidebar after a cart update.
 * Primary trigger: MutationObserver on #main-cart-items (fires when items list changes).
 * Secondary trigger: pubsub cartUpdate event (fires when cart.js publish succeeds).
 * After refresh (and on load): moves Dcart .scDiscount__container into the discount details and opens it when there is an active discount.
 */
(function () {
  var refreshTimer;
  var dcartDeadline = 6000;
  // Temporary toggle: keep relocation logic in code, but disable on initial page load.
  var enableDcartMoveOnPageLoad = false;

  function openDiscountDetailsIfActive() {
    var detailsEl = document.getElementById('em-discount-details');
    if (!detailsEl) return;
    var info = document.querySelector('.sc_simple-info');
    var filled = info && (info.querySelector('.sc_simple-info__tag') || (info.textContent && info.textContent.trim().length > 0));
    if (filled) detailsEl.setAttribute('open', '');
  }

  function moveDcartIntoDetails() {
    var slot = document.getElementById('em-discount-details-content');
    var detailsEl = document.getElementById('em-discount-details');
    if (!slot || !detailsEl) return;
    var container = document.querySelector('.scDiscount__container');
    if (!container) return false;
    if (container.closest('#em-discount-details')) {
      openDiscountDetailsIfActive();
      return true;
    }
    slot.insertBefore(container, slot.firstChild);
    openDiscountDetailsIfActive();
    return true;
  }

  function runDcartLogic() {
    var slot = document.getElementById('em-discount-details-content');
    if (!slot) return;
    if (moveDcartIntoDetails()) return;
    var start = Date.now();
    var observer = new MutationObserver(function () {
      if (moveDcartIntoDetails()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
      moveDcartIntoDetails();
      openDiscountDetailsIfActive();
    }, Math.max(0, dcartDeadline - (Date.now() - start)));
  }

  function refreshCartTotals() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var sectionId = footer.dataset.id;
    if (!sectionId) return;

    fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#main-cart-footer .js-contents');
        var currentContent = document.querySelector('#main-cart-footer .js-contents');
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          runDcartLogic();
        }
      })
      .catch(function (e) {
        console.error('[em-cart-totals-update] fetch failed:', e);
      });
  }

  function debouncedRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartTotals, 300);
  }

  if (enableDcartMoveOnPageLoad) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runDcartLogic);
    } else {
      runDcartLogic();
    }
  }

  var cartItemsEl = document.getElementById('main-cart-items');
  if (cartItemsEl) {
    var observer = new MutationObserver(debouncedRefresh);
    observer.observe(cartItemsEl, { childList: true, subtree: true });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cart-items') {
        debouncedRefresh();
      }
    });
  }
})();
